export default {
  title: 'Wie wohlhabend sind Sie im Vergleich?',
  subline:
    'Finden Sie mit unserem Rechner heraus, wo Sie in der Gesellschaft punkto Einkommen und Vermögen stehen.',
  publication: 'Publiziert am 27. Dezember 2023',
  //form
  form_title: 'Ihre Angaben',
  form_disclaimer: 'Die Daten werden zu keinem Zeitpunkt gespeichert.',
  income_label: 'Ihr Bruttoeinkommen pro Jahr',
  income_subline_1: 'Individuelles Bruttoeinkommen pro Jahr',
  income_subline_2: 'inklusive Kapital- und Renteneinkommen',
  income_info:
    'Falls Sie in einem Haushalt mit mehreren Personen leben und diese Situation berechnen lassen wollen, teilen Sie das gesamte gemeinsame Bruttoeinkommen durch die entsprechende Anzahl erwachsener Personen.',
  vermoegen_label: 'Ihr Vermögen',
  vermoegen_subline_1:
    'Alle individuellen Vermögenswerte wie Erspartes, Autos, Immobilien, Aktien etc. ',
  vermoegen_subline_2:
    'inklusive Pensionskasse und Säule 3a abzüglich aller Schulden.',
  vermoegen_info:
    'Falls Sie in einem Haushalt mit mehreren Personen leben und diese Situation berechnen lassen wollen, teilen Sie das gesamte gemeinsame Vermögen durch die entsprechende Anzahl erwachsener Personen.',
  adults_in_household: 'Erwachsene im Haushalt',
  kids_in_household: 'Kinder im Haushalt',
  canton: 'In welchem Kanton leben Sie?',
  age: 'Ihr Alter',
  age_group: 'Ihre Altersgruppe',
  show_chart: 'Anzeigen',
  // Group Display Bar
  group_display_bar_title: 'Sie gehören zu folgender Wohlstandsgruppe',
  group_display_bar_middle_income: 'Ihr Einkommen',
  group_display_bar_middle_savings: 'Ihr Vermögen',
  group_display_bar_x_axis_title: 'Anteil an den Steuerzahlern in der Schweiz',
  //groups
  group_1: 'Reich',
  group_2: 'Obere Mitte',
  group_3: 'Mitte',
  group_4: 'Untere Mitte',
  group_5: 'Armutsgefährdet',
  group_6: 'Arm',
  // EINKOMMEN CHART
  einkommen_chart_title:
    'Bevölkerung aufgeteilt in 20 gleich grosse Einkommensgruppen',
  y_axis_title_income: 'Sie gehören zu folgender Einkommensgruppe',
  y_axis_subline_1_income: 'Bruttoeinkommen pro Jahr in Fr.',
  einkommen_chart_you: 'Sie',
  income_reading_1:
    'Mit Ihrem Einkommen gehören Sie zu den 5 Prozent der Schweizer Bevölkerung mit dem tiefsten Einkommen',
  income_reading_2:
    'Die obersten 5 Prozent haben ein durchschnittliches Einkommen von {{value}} Fr. pro Jahr.',
  income_reading_3:
    'Mit Ihrem Einkommen gehören Sie zu den 5 Prozent der Schweizer Bevölkerung mit dem höchsten Einkommen',
  income_reading_4:
    '. Das durchschnittliche Einkommen dieser Gruppe beträgt {{value}} Fr. pro Jahr.',
  income_reading_5:
    'Sie gehören zu den 5 Prozent der Schweizer Bevölkerung mit einem durchschnittlichen Einkommen von {{value}} Fr.',
  income_reading_6:
    '{{value}}% verdienen mehr als Sie. Die obersten 5 Prozent haben ein durchschnittliches Einkommen von {{value1}} Fr. pro Jahr.',
  income_annotation:
    'Sie gehören zu dieser Gruppe. 70% verdienen mehr als Sie.',
  // VERMOGENSCHART
  vermoegen_chart_title:
    'Bevölkerung aufgeteilt in 20 gleich grosse Vermögensgruppen',
  y_axis_title_wealth: 'Sie gehören zu folgender Vermögensgruppe',
  y_axis_subline_1_wealth: 'Vermögen inkl. Rentenvorsorge in Fr.',
  wealth_reading_1:
    'Sie gehören zu den 5 Prozent der Schweizer Bevölkerung mit einem durchschnittlichen Vermögen von {{value}} Fr.',
  wealth_reading_2:
    '{{value}} Prozent besitzen mehr als Sie. Die obersten 5 Prozent besitzen ein durchschnittliches Vermögen von 6,2 Mio. Fr.',
  // VERMOGENSCHART
  source: 'Quelle',
  lower_5: 'unterste 5%',
  upper_5: 'oberste 5%',
  age_group_1: '18-65 Jahre',
  age_group_2: '65 Jahre und älter',
}
